import React, { PureComponent } from 'react';
import {
	SellWrapper,
	Link,
	SubBoxIcon,
	SmText,
	MdText,
} from './marketingCtaStyles';

class MenuCta extends PureComponent {
	render () {
		return (
			<SellWrapper>
				<Link className="mpHeader-top-sell-cta" href="/sell/marketplace/" title="Sell on Cratejoy">
					<SubBoxIcon />
					<MdText>Sell on Cratejoy</MdText>
					<SmText>Sell</SmText>
				</Link>
			</SellWrapper>
		);
	}
}

export default MenuCta;
